import EmployeesConstants from 'Shared/constants/Employees.constants';
import { fetchEmployees } from 'Shared/api/employee.api';

export const getEmployeeEmailSuccess = payload => ({
  type: EmployeesConstants.Actions.GET_EMPLOYEES_EMAIL_SUCCESS,
  payload,
});

export const getEmployeeEmails = () => dispatch => {
  return fetchEmployees()
    .then(response => {
      dispatch(getEmployeeEmailSuccess(response.data.data));
      return response;
    })
    .catch(error => {
      return error.response;
    });
};
